module.exports = __webpack_public_path__ + "img/question1.0afcc987.png";